export interface ISpeakersType {
  label_ru: string;
  label_en: string;
  value: string;
}

const speakersTypes: ISpeakersType[] = [
  {
    label_ru: 'Стандартный',
    label_en: 'Default',
    value: 'Default',
  },
  {
    label_ru: 'Горизонтальный',
    label_en: 'Horizontal',
    value: 'Horizontal',
  },
  {
    label_ru: 'Колонками',
    label_en: 'Columns',
    value: 'Columns',
  },
  {
    label_ru: 'Карточки',
    label_en: 'Cards',
    value: 'Cards',
  },
];

export default speakersTypes;
